<template>
  <div class="page">
    <c-source-page
      :table="table"
      :columns="columns"
      :filter="filter"
      :pagination="pagination"
      resource="search_records"
    />
  </div>
</template>

<script>
import { Vue, Component } from 'vue-property-decorator';
import _ from 'lodash';

@Component
export default class SearchrecordsShow extends Vue {
  pagination = {}

  filter = []

  table = {
    data: []
  };

  get columns() {
    return [
      {
        prop: 'user.nickname',
        label: '用户名',
        renderCell(h, { row }) {
          return <c-link-button to={{ name: 'users.show', params: { id: _.get(row, 'user.id', '') } }}>{_.get(row, 'user.nickname', '')}</c-link-button>
        }
      },
      {
        prop: 'user.avatar',
        label: '头像',
        renderCell: 'image'
      },
      {
        prop: 'count',
        label: '点击次数'
      },
    ]
  }

  mounted() {
    this.fetchData();
  }

  async fetchData() {
    const data = await this.$request.get(`/search_records/${this.$route.params.id}`);
    this.table.data = data.user_search_record_relations
  }
}
</script>
